import { formatarReais } from '@du/shared'
import { cn } from '../lib/cn.js'

/**
 * Selo de preço do guia: "amarelo, borda preta, levemente girado".
 * O giro vem do token --du-selo-giro (-7deg), não de número solto.
 *
 * Preto sobre amarelo é 13.7:1 — o único par permitido sobre amarelo.
 * Branco sobre amarelo dá 1.43:1 e está proibido nos tokens.
 */
export type PriceSealProps = {
  precoCents: number
  /** Texto curto acima do valor, tipo "A PARTIR DE". */
  rotulo?: string | undefined
  tamanho?: 'sm' | 'md' | 'lg' | undefined
  /** Desliga o giro quando o selo entra numa lista alinhada. */
  reto?: boolean | undefined
  className?: string | undefined
}

export function PriceSeal({ precoCents, rotulo, tamanho = 'md', reto, className }: PriceSealProps) {
  const [moeda, valor] = formatarReais(precoCents).split(' ')
  return (
    <span
      className={cn('du-selo', `du-selo--${tamanho}`, reto && 'du-selo--reto', className)}
      aria-label={formatarReais(precoCents)}
    >
      {rotulo ? <span className="du-selo__rotulo">{rotulo}</span> : null}
      <span className="du-selo__valor" aria-hidden>
        <span className="du-selo__moeda">{moeda}</span>
        {valor}
      </span>
    </span>
  )
}
